import { render } from "./UPPHistory.vue?vue&type=template&id=3fc89ff6"
import script from "./UPPHistory.vue?vue&type=script&lang=ts"
export * from "./UPPHistory.vue?vue&type=script&lang=ts"
script.render = render

export default script